import { PlusIcon, UsersRoundIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { MODAL_TEAM } from '@/components/organisms/Modals/ModalConductor';
import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { pushModal } from '@/redux/modals/actions';
import { getPermissions } from '@/redux/permissions/selectors';
import { trackEvent } from '@/segment/segment';
import { actions } from '@/shared/types/permissions';
import { EventName } from '@/shared/types/segment';
import { RootState } from '@/shared/types/state';

/**
 * EmptyTeams - Empty state component shown when no teams exist
 */
export const EmptyTeams = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const canWrite = useSelector((state: RootState) => getPermissions(state, 'teams', actions.WRITE));

  const handleCreateClick = () => {
    trackEvent(EventName.ClickCreateAccessTeam);
    dispatch(pushModal(MODAL_TEAM));
  };

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <UsersRoundIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('teams.empty_state.title')}</EmptyTitle>
        <EmptyDescription>{t('teams.empty_state.description')}</EmptyDescription>
      </EmptyHeader>
      {canWrite && (
        <EmptyContent>
          <Button size="sm" onClick={handleCreateClick}>
            <PlusIcon size={16} />
            {t('common.create')}
          </Button>
        </EmptyContent>
      )}
    </Empty>
  );
};
